import { css } from '@emotion/css'
import { breakpoint, mediaQueryHelper, spacing } from '@offerzen/pinata-shame'

const styles = {
  cardBody: css({
    display: 'grid',
    gap: spacing.medium,

    [mediaQueryHelper(breakpoint.phone)]: {
      gridTemplateColumns: '1fr auto',
      alignItems: 'flex-end',
      gap: spacing.default,
    },
  }),
}

export default styles
